"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var applyBulkItemActionOperation_1 = require("owa-service/lib/operation/applyBulkItemActionOperation");
var Utils_1 = require("owa-service/lib/Utils");
var applyBulkItemActionRequest_1 = require("owa-service/lib/factory/applyBulkItemActionRequest");
/**
 * Always delete conversation Service
 * @param sourceFolderId the source folderId
 * @param emailAddresses emailaddresses
 * @param itemPropertytoUpdate the item property to update
 * @return the ApplyBulkItemActionResponse
 */
function alwaysDeleteConversationsService(emailAddresses, destinationFolderId, sourceFolderId, keepNType, keepNCount) {
    var requestBody = applyBulkItemActionRequest_1.default({
        ActionType: 0 /* Move */,
        DestinationFolderId: { Id: destinationFolderId },
        EmailAddresses: emailAddresses,
        SourceFolderId: { Id: sourceFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
    });
    return applyBulkItemActionOperation_1.default({
        Header: Utils_1.getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
exports.default = alwaysDeleteConversationsService;
//# sourceMappingURL=alwaysDeleteConversationsService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/services/alwaysDeleteConversationsService.js
// module id = 5643
// module chunks = 62